import React from 'react';
import Social from './Social';

function Contact(){
    return (
        <div className="contact">
            <p id="title">Stay Connected!</p>
            <Social id="icons"/>
        </div>
    )
}

export default Contact;